import classNames from 'classnames';
import { first, upperCase } from 'lodash';
import { useEffect } from 'react';
import { BiGlobe } from 'react-icons/bi';
import useScrollToTop from '../common/hooks/use-scroll-to-top';
import { useData } from '../report/use-data';
import { usePaSurveyParams } from '../report/use-pa-survey-params';
import useAppState from './use-app-state';

import LogoPatientDynamic from '../components/LogoPatientDynamic';
import PatientOrgContainer from '../patient/hooks/PatientOrgContainer';
import { usePatientOrgData } from '../patient/hooks/usePatientOrgData';

function PaSurveyHeaderContent() {
  useEffect(() => {
    const el = first(window.document.getElementsByTagName('html'));
    el?.setAttribute('data-theme', 'patientLight');
  }, []);

  const [
    {
      dataState: { survey },
    },
  ] = useData({ initData: true });

  const container = PatientOrgContainer.useContainer();
  const { orgId } = usePaSurveyParams();

  // Fetch organization data
  // URL 파라미터에서 직접 orgId를 가져와서 사용 (GraphQL 실패 시에도 작동)
  const orgIdNumber = orgId ? parseInt(orgId, 10) : null;
  usePatientOrgData({
    organizationId: orgIdNumber,
  });

  useScrollToTop();

  const [{ localeInfo }, { openLocaleModal }] = useAppState();

  return (
    <>
      <div className='navbar z-20 gap-2 p-0'>
        <div className='flex-1 font-bold text-2xl'>
          <div className='h-6'>
            <LogoPatientDynamic
              logoUrl={container.logoUrl}
              isLoading={container.isLoading}
              className='w-auto'
            />
          </div>
        </div>
        <div className='flex'>
          <div
            className={classNames(
              'btn bg-transparent border-black border-1_5 border-opacity-10 p-2 min-h-0 h-auto',
              survey?.id == null && 'hidden',
            )}
            onClick={() => {
              openLocaleModal();
            }}
          >
            <BiGlobe size={'1.2rem'} />
            <span className='text-xs'>{upperCase(localeInfo?.label)}</span>
          </div>
        </div>
      </div>
    </>
  );
}

// Provider는 PaSurveyHomePage에서 감싸므로 여기서는 제거
export default PaSurveyHeaderContent;
